import React from 'react'
import api from '../api/api'
import Cookies from 'universal-cookie'
const cookies = new Cookies()

class Service extends React.Component {
    constructor(props) {
        super(props)
        this.state = {}
    }

    async checkToken() {
        try {
            if (!cookies.get('accessToken') && window.location.pathname !== '/login' && window.location.pathname !== '/register' && window.location.pathname !== '/request-password-recovery') window.location.replace('/login')
            const data = await api.checkToken(cookies.get('accessToken'))
            const { accessToken, accessExpired } = data.data
            cookies.set('accessToken', accessToken, { path: '/' })
            return accessExpired
        } catch (e) {
            if (e.response.status === 417) return 0
            return 60000
        }
    }

    async getConfig() {
        const system = await api.getConfig()
        cookies.set('system', system)
        return system
    }

    async componentWillMount() {
        // TODO интервал прирывается если удалить кукисы
        if (window.location.pathname === '/login' || window.location.pathname === '/register' || window.location.pathname === '/request-password-recovery') return
        let timeoutTime = await this.checkToken()
        if (!cookies.get('system')) this.getConfig()
        if ((!cookies.get('accessToken') || !timeoutTime) && (window.location.pathname !== '/login' && window.location.pathname !== '/register' && window.location.pathname !== '/request-password-recovery')) window.location.replace('/login')
        const intervalTime = cookies.get('accessExpired') ? Number(cookies.get('accessExpired')) * 1000 : 360000
        if (cookies.get('accessToken')) {
            timeoutTime = await this.checkToken()
            const checkTokenTimeout = setTimeout(() => {
                this.checkToken()
                const checkTokenInterval = setInterval(() => {
                    this.checkToken().then((timeoutTime) => {
                        if (!timeoutTime) {
                            clearTimeout(checkTokenTimeout)
                            clearInterval(checkTokenInterval)
                            window.location.replace('/login')
                        }
                    })
                }, intervalTime)
            }, timeoutTime)
        }
    }

    render() {
        return (
            <div style={{ display: 'none' }}></div>
        )
    }
}

export default Service



// WEBPACK FOOTER //
// ./src/lib/Service.jsx